<template>
  <div :id="chartId" :style="{ width:`${width}px`, height:`${height}px` }"></div>
</template>

<script>
import * as echarts from 'echarts'
import 'echarts-liquidfill'

export default {
  name: 'WaterBall',
  props: {
    value: {type: Number, required: true}, // 数值 0~100
    isYin: {type: Boolean, default: false}, // 是否是“阴”值
    width: {type: Number, default: 200},
    height: {type: Number, default: 200}
  },
  data() {
    return {
      chartId: 'water-ball-' + Math.random().toString(36).substr(2, 9),
      chartInstance: null
    }
  },
  mounted() {
    this.initChart()
  },
  watch: {
    value() {
      this.initChart()
    },
    isYin() {
      this.initChart()
    }
  },
  methods: {
    initChart() {
      if (this.chartInstance) {
        this.chartInstance.dispose()
      }

      this.chartInstance = echarts.init(document.getElementById(this.chartId))

      const percent = this.value / 100
      this.chartInstance.setOption({
        title: [
          // {
          //   text: `${this.value}分`,  // 主分数
          //   left: 'center',
          //   top: '40%', // 靠近水球中心
          //   textStyle: {
          //     fontSize: 20,
          //     color: 'white'
          //   }
          // },
          {
            text: this.isYin ? '阴指数' : '阳指数',  // 水球底部的文字
            left: 'center',
            top: '70%', // 靠近底部
            textStyle: {
              fontSize: 20,
              color: 'white'
            }
          }
        ],
        // backgroundColor: {
        //   image: '/images/yin.png'
        // },
        graphic: {
          type: 'image',
          z: -10, // 图层放到最底下
          style: {
            image: this.isYin ? '/images/yin.png' : '/images/yang.png',
            width: this.width,
            height: this.height
          },
          left: 0,
          top: 0
        },
        series: [{
          type: 'liquidFill',
          data: [percent, percent], // 层叠水浪
          radius: '80%',
          center: ['50%', '50%'],
          itemStyle: {
            color: {
              type: 'linear',
              x: 0, y: 0, x2: 0, y2: 1,
              colorStops: this.isYin
                  ? [
                    {offset: 1, color: '#5b81c4'},
                    {offset: 0, color: '#2158c8'}
                  ]
                  : [
                    {offset: 1, color: '#f0979e'},
                    {offset: 0, color: '#da312d'}
                  ]
            },
            opacity: 0.85,
            shadowBlur: 0, // 去除液面投影
            shadowColor: 'transparent'
          },
          backgroundStyle: {
            color: 'transparent'
          },
          outline: {
            show: false
          },
          label: {
            formatter: `${this.value}`,
            fontSize: 30,
            color: 'white'
          }
        }]
      })
    }
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose()
    }
  }
}
</script>
